import { createFileRoute, notFound } from '@tanstack/react-router';

import { CinemaPageView } from '@/components/site/pages';
import { CINEMA_PUBLIC_ENABLED } from '@/lib/cinema-providers';
import { seoHead } from '@/lib/seo';
import { loadCinemaPage } from '@/server/functions/pages';

export const Route = createFileRoute('/cinema')({
    beforeLoad: () => {
        if (!CINEMA_PUBLIC_ENABLED) throw notFound();
    },
    loader: () => loadCinemaPage(),
    head: () =>
        seoHead({
            title: 'סרטים בקולנוע - אשקלון והסביבה',
            description:
                'זמני הקרנה מעודכנים מ-HOT CINEMA, סינמה סיטי, קולנוע לב, פלאנט וגלובוס סנטר. בחרו סרט ורכשו כרטיס.',
            path: '/cinema',
            keywords: 'קולנוע אשקלון, סרטים אשקלון, HOT CINEMA אשקלון, סינמה סיטי',
        }),
    component: CinemaPage,
});

function CinemaPage() {
    const data = Route.useLoaderData();
    return <CinemaPageView {...data} />;
}
